export interface JellyfinAuthResult {
  userId: string;
  serverName: string;
}

export interface JellyfinItem {
  Id: string;
  Name: string;
  Type: string;
  Overview?: string;
  ProductionYear?: number;
  ImageTags?: { Primary?: string };
}

function stripTrailingSlash(url: string): string {
  return url.replace(/\/+$/, "");
}

export const JellyfinAdapter = {
  async authenticate(baseUrl: string, apiKey: string): Promise<JellyfinAuthResult> {
    const res = await fetch(`${stripTrailingSlash(baseUrl)}/Users?api_key=${encodeURIComponent(apiKey)}`);
    if (!res.ok) throw new Error("Invalid API key");
    const users: Array<{ Id: string; ServerId: string }> = await res.json();
    if (!users.length) throw new Error("No user found");
    return { userId: users[0].Id, serverName: users[0].ServerId };
  },

  async getLibrary(
    baseUrl: string,
    apiKey: string,
    userId: string,
    opts: { type?: string; parentId?: string; limit?: number; startIndex?: number } = {}
  ): Promise<{ items: JellyfinItem[]; total: number }> {
    const params = new URLSearchParams({
      api_key: apiKey,
      Recursive: "true",
      IncludeItemTypes: opts.type ?? "Movie,Series",
      Limit: String(opts.limit ?? 50),
      StartIndex: String(opts.startIndex ?? 0),
      fields: "Name,Overview,ProductionYear,ImageTags,PrimaryImageAspectRatio",
      UserId: userId,
    });
    if (opts.parentId) params.set("ParentId", opts.parentId);
    const res = await fetch(`${stripTrailingSlash(baseUrl)}/Items?${params.toString()}`);
    if (!res.ok) throw new Error(`Jellyfin library: HTTP ${res.status}`);
    const data: { Items: JellyfinItem[]; TotalRecordCount: number } = await res.json();
    return { items: data.Items ?? [], total: data.TotalRecordCount };
  },

  getStreamUrl(baseUrl: string, apiKey: string, itemId: string): string {
    return `${stripTrailingSlash(baseUrl)}/Videos/${itemId}/main.m3u8?api_key=${encodeURIComponent(apiKey)}`;
  },
};
